import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./BookSession.css";

import oneOnOne from "../../assets/topmate/1-1Session.png";
import careerGuidance from "../../assets/topmate/Careerguidance.webp";
import interviewTips from "../../assets/topmate/Interviewprep&tips.webp";
import mockInterview from "../../assets/topmate/Mockinterview.webp";
import quickChat from "../../assets/topmate/Quickchat.webp";
import resumeReview from "../../assets/topmate/Resumereview.webp";
import portfolioReview from "../../assets/topmate/Portfolio&GithubReview.png";
import discoveryCall from "../../assets/topmate/DiscoveryCall.png";
import linkedInOpt from "../../assets/topmate/LinkedInProfileOptimization.png";
import projectIdea from "../../assets/topmate/ProjectIdeaDiscussion.png";
import askMeAny from "../../assets/topmate/AskMeAnything.png";
import haveQuestion from "../../assets/topmate/HaveAQuestion.png";

const TOPMATE_PROFILE_URL = "https://topmate.io/praveen_kumarbofficial/";

const SERVICE_LINKS = {
  oneOnOne: "https://topmate.io/praveen_kumarbofficial/1792815",
  careerGuidance: "https://topmate.io/praveen_kumarbofficial/1792834",
  interviewTips: "https://topmate.io/praveen_kumarbofficial/1792836",
  mockInterview: "https://topmate.io/praveen_kumarbofficial/1792827",
  quickChat: "https://topmate.io/praveen_kumarbofficial/1792816",
  resumeReview: "https://topmate.io/praveen_kumarbofficial/1792822",
  portfolioReview: "https://topmate.io/praveen_kumarbofficial/1792837",
  discoveryCall: "https://topmate.io/praveen_kumarbofficial/1791702",
  linkedinOpt: "https://topmate.io/praveen_kumarbofficial/1792858",
  projectIdea: "https://topmate.io/praveen_kumarbofficial/1792840",
  askMeAnything: "https://topmate.io/praveen_kumarbofficial/1792811/pay",
  haveQuestion: "https://topmate.io/praveen_kumarbofficial/1792860/pay",
};

const services = [
  { id: 1, title: "1-on-1 Session", img: oneOnOne, link: SERVICE_LINKS.oneOnOne, tag: "Personal" },
  { id: 2, title: "Career Guidance", img: careerGuidance, link: SERVICE_LINKS.careerGuidance, tag: "Direction" },
  { id: 3, title: "Interview Prep & Tips", img: interviewTips, link: SERVICE_LINKS.interviewTips, tag: "Placement" },
  { id: 4, title: "Mock Interview", img: mockInterview, link: SERVICE_LINKS.mockInterview, tag: "Practice" },
  { id: 5, title: "Quick Chat", img: quickChat, link: SERVICE_LINKS.quickChat, tag: "Fast Help" },
  { id: 6, title: "Resume Review", img: resumeReview, link: SERVICE_LINKS.resumeReview, tag: "ATS Ready" },
  { id: 7, title: "Portfolio & GitHub Review", img: portfolioReview, link: SERVICE_LINKS.portfolioReview, tag: "Showcase" },
  { id: 8, title: "Discovery Call", img: discoveryCall, link: SERVICE_LINKS.discoveryCall, tag: "Explore" },
  { id: 9, title: "LinkedIn Profile Optimization", img: linkedInOpt, link: SERVICE_LINKS.linkedinOpt, tag: "Branding" },
  { id: 10, title: "Project Idea Discussion", img: projectIdea, link: SERVICE_LINKS.projectIdea, tag: "Build" },
  { id: 11, title: "Ask Me Anything", img: askMeAny, link: SERVICE_LINKS.askMeAnything, tag: "Open Q&A" },
  { id: 12, title: "Have A Question?", img: haveQuestion, link: SERVICE_LINKS.haveQuestion, tag: "Support" },
];

export default function BookSession() {
  const containerRef = useRef(null);

  useEffect(() => {
    const root = containerRef.current;
    if (!root) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("bs-animate");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    const targets = root.querySelectorAll(".bs-anim-target");
    targets.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const handleScrollToServices = (e) => {
    e.preventDefault();
    const target = document.getElementById("services");
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="bs-shell" ref={containerRef}>
      {/* AMBIENT BACKGROUND GLOWS & PATTERNS */}
      <div className="bs-bg-glow bs-bg-glow-1" />
      <div className="bs-bg-glow bs-bg-glow-2" />
      <div className="bs-bg-glow bs-bg-glow-3" />
      <div className="bs-dot-matrix bs-dot-matrix-left" aria-hidden="true" />
      <div className="bs-dot-matrix bs-dot-matrix-right" aria-hidden="true" />

      {/* FLOATING SPARKLE ACCENTS */}
      <div className="bs-sparkle bs-sparkle-1" aria-hidden="true">✦</div>
      <div className="bs-sparkle bs-sparkle-2" aria-hidden="true">✦</div>
      <div className="bs-sparkle bs-sparkle-3" aria-hidden="true">✦</div>
      <div className="bs-sparkle bs-sparkle-4" aria-hidden="true">✦</div>

      {/* HERO SECTION */}
      <section className="bs-hero-wrapper bs-anim-target">
        {/* Left Flank: Floating 3D Calendar with Clock */}
        <div className="bs-hero-flank bs-hero-calendar" aria-hidden="true">
          <div className="bs-calendar-card">
            {/* Top Binder Rings */}
            <div className="bs-calendar-rings">
              <span className="bs-ring" />
              <span className="bs-ring" />
              <span className="bs-ring" />
            </div>
            {/* Calendar Header */}
            <div className="bs-calendar-header-bar" />
            {/* Calendar Tile Grid */}
            <div className="bs-calendar-grid">
              <div className="bs-cal-tile" />
              <div className="bs-cal-tile" />
              <div className="bs-cal-tile" />
              <div className="bs-cal-tile" />
              <div className="bs-cal-tile active" />
              <div className="bs-cal-tile" />
              <div className="bs-cal-tile" />
              <div className="bs-cal-tile" />
              <div className="bs-cal-tile" />
            </div>
            {/* 3D Floating Clock Badge */}
            <div className="bs-clock-badge">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="12" cy="12" r="10" />
                <polyline points="12 6 12 12 16 14" />
              </svg>
            </div>
          </div>
        </div>

        {/* Center: Main Hero Content */}
        <div className="bs-hero-center">
          <div className="bs-pill-badge">
            <span className="bs-crown-icon">👑</span>
            <span className="bs-pill-text">PREMIUM MENTORSHIP • TOPMATE</span>
          </div>

          <h1 className="bs-hero-title">
            Book a <span className="bs-gradient-text">Premium Session</span> With Me
          </h1>

          <p className="bs-hero-sub">
            Get career guidance, resume review, LinkedIn optimization, mock interviews,
            portfolio feedback, and 1-on-1 mentorship through Topmate.
          </p>

          <div className="bs-hero-actions">
            <a
              className="bs-primary-btn"
              href={TOPMATE_PROFILE_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg className="bs-btn-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                <polyline points="15 3 21 3 21 9" />
                <line x1="10" y1="14" x2="21" y2="3" />
              </svg>
              <span>Visit Topmate Profile</span>
            </a>
            <a
              href="#services"
              className="bs-secondary-btn"
              onClick={handleScrollToServices}
            >
              <span>Explore Services</span>
              <svg className="bs-btn-svg-chevron" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </a>
          </div>
        </div>

        {/* Right Flank: Feature Highlights Glass Card */}
        <div className="bs-hero-flank bs-hero-features" aria-hidden="true">
          <div className="bs-features-card">
            <div className="bs-feature-item">
              <span className="bs-feature-icon bs-icon-grad-blue">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
                  <path d="M6 12v5c3 3 9 3 12 0v-5" />
                </svg>
              </span>
              <span className="bs-feature-label">Career Guidance</span>
            </div>
            <div className="bs-feature-item">
              <span className="bs-feature-icon bs-icon-grad-cyan">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                  <polyline points="14 2 14 8 20 8" />
                  <line x1="16" y1="13" x2="8" y2="13" />
                  <line x1="16" y1="17" x2="8" y2="17" />
                  <polyline points="10 9 9 9 8 9" />
                </svg>
              </span>
              <span className="bs-feature-label">Resume Review</span>
            </div>
            <div className="bs-feature-item">
              <span className="bs-feature-icon bs-icon-grad-purple">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </span>
              <span className="bs-feature-label">Mock Interviews</span>
            </div>
            <div className="bs-feature-item">
              <span className="bs-feature-icon bs-icon-grad-pink">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="16 18 22 12 16 6" />
                  <polyline points="8 6 2 12 8 18" />
                </svg>
              </span>
              <span className="bs-feature-label">Portfolio Feedback</span>
            </div>
          </div>
        </div>
      </section>

      {/* SERVICE SUMMARY CARDS (METRICS) */}
      <section className="bs-metrics-section bs-anim-target">
        <div className="bs-metrics-grid">
          {/* Metric 1 */}
          <div className="bs-metric-card">
            <div className="bs-metric-icon-wrap bs-icon-lightning">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
              </svg>
            </div>
            <div className="bs-metric-info">
              <span className="bs-metric-value">12+</span>
              <p className="bs-metric-label">Service Options</p>
            </div>
          </div>

          {/* Metric 2 */}
          <div className="bs-metric-card">
            <div className="bs-metric-icon-wrap bs-icon-users">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
              </svg>
            </div>
            <div className="bs-metric-info">
              <span className="bs-metric-value">1-on-1</span>
              <p className="bs-metric-label">Personal Guidance</p>
            </div>
          </div>

          {/* Metric 3 */}
          <div className="bs-metric-card">
            <div className="bs-metric-icon-wrap bs-icon-shield">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
              </svg>
            </div>
            <div className="bs-metric-info">
              <span className="bs-metric-value">Secure</span>
              <p className="bs-metric-label">Topmate Booking</p>
            </div>
          </div>
        </div>
      </section>

      {/* AVAILABLE SESSIONS SECTION */}
      <section id="services" className="bs-services-section">
        <div className="bs-section-head bs-anim-target">
          <span className="bs-section-kicker">AVAILABLE SESSIONS</span>
          <h2 className="bs-section-title">
            Choose the service that matches your current goal
          </h2>
          <p className="bs-section-sub">
            Each card opens directly in Topmate in a new tab.
          </p>
        </div>

        <div className="bs-cards-wrap">
          {services.map((s, index) => {
            const formattedIndex = s.id < 10 ? `0${s.id}` : `${s.id}`;
            return (
              <article
                className="bs-card bs-anim-target"
                key={s.id}
                style={{ transitionDelay: `${index * 35}ms` }}
              >
                {/* Card Top: Category Badge & Number */}
                <div className="bs-card-top">
                  <span className="bs-card-tag">{s.tag}</span>
                  <span className="bs-card-no">{formattedIndex}</span>
                </div>

                {/* Card Image Container */}
                <div className="bs-card-image-wrap">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="bs-card-img"
                    loading="lazy"
                  />
                </div>

                {/* Card Body */}
                <div className="bs-card-body">
                  <h3 className="bs-card-title">{s.title}</h3>
                  <p className="bs-card-text">
                    Book this session for focused guidance.
                  </p>

                  {/* Metadata Row: 1-on-1 & Online */}
                  <div className="bs-card-meta-row">
                    <span className="bs-card-meta-item">
                      <svg className="bs-meta-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                        <circle cx="12" cy="7" r="4" />
                      </svg>
                      <span>1-on-1</span>
                    </span>
                    <span className="bs-card-meta-item">
                      <svg className="bs-meta-svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="23 7 16 12 23 17 23 7" />
                        <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
                      </svg>
                      <span>Online</span>
                    </span>
                  </div>

                  {/* Gradient Booking Button */}
                  <a
                    href={s.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="bs-book-btn"
                  >
                    <span>Book via Topmate</span>
                    <svg className="bs-book-btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <line x1="7" y1="17" x2="17" y2="7" />
                      <polyline points="7 7 17 7 17 17" />
                    </svg>
                  </a>
                </div>
              </article>
            );
          })}
        </div>
      </section>

      {/* CONTACT & SECURITY CTA BANNER */}
      <section className="bs-contact-cta-section bs-anim-target">
        <div className="bs-contact-cta-card">
          {/* Left Block: Not sure which session fits? */}
          <div className="bs-cta-left">
            <div className="bs-cta-icon-bulb">
              <span>💡</span>
            </div>
            <div className="bs-cta-text-block">
              <h3 className="bs-cta-heading">Not sure which session fits?</h3>
              <p className="bs-cta-description">
                Feel free to reach out and I'll help you choose the right session based on your goals.
              </p>
            </div>
          </div>

          {/* Center Action: Contact Me Button */}
          <div className="bs-cta-center">
            <Link to="/contact" className="bs-cta-contact-btn">
              <svg className="bs-cta-btn-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                <rect x="2" y="4" width="20" height="16" rx="2" />
                <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
              </svg>
              <span>Contact Me</span>
              <svg className="bs-cta-btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <line x1="7" y1="17" x2="17" y2="7" />
                <polyline points="7 7 17 7 17 17" />
              </svg>
            </Link>
          </div>

          {/* Vertical Divider */}
          <div className="bs-cta-divider" aria-hidden="true" />

          {/* Right Block: Booking & Payment via Topmate */}
          <div className="bs-cta-right">
            <div className="bs-cta-icon-shield">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z" />
              </svg>
            </div>
            <div className="bs-cta-text-block">
              <h4 className="bs-cta-subheading">Booking & Payment via Topmate</h4>
              <p className="bs-cta-description">
                All sessions are booked and paid securely through Topmate. You'll be redirected to Topmate.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
